
import React from "react";
import { FormDialog } from "@/components/shared/FormDialog";
import { FactoryForm, FactoryFormValues } from "./FactoryForm";

interface FactoryDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (values: FactoryFormValues) => Promise<void>;
  defaultValues: FactoryFormValues;
  isEditing: boolean;
}

export const FactoryDialog = ({
  open,
  onOpenChange,
  onSubmit,
  defaultValues,
  isEditing
}: FactoryDialogProps) => {
  return (
    <FormDialog
      title={isEditing ? "Edit Factory" : "Add New Factory"}
      open={open}
      onOpenChange={onOpenChange}
    >
      <FactoryForm
        onSubmit={onSubmit}
        defaultValues={defaultValues}
        onCancel={() => onOpenChange(false)}
        isEditing={isEditing}
      />
    </FormDialog>
  );
};
